<div class="sd-bg">

  <!-- Marigold garland -->
  <div class="sd-garland" aria-hidden="true"></div>

  <!-- Mute toggle -->
  <button type="button" class="sd-mute" (click)="toggleMute()"
          [attr.aria-label]="muted ? 'Unmute' : 'Mute'" [attr.aria-pressed]="muted">
    <svg *ngIf="!muted" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M4 9h4l5-4v14l-5-4H4z"></path>
      <path d="M16.5 8.5a5 5 0 0 1 0 7M19 6a8.5 8.5 0 0 1 0 12"></path>
    </svg>
    <svg *ngIf="muted" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M4 9h4l5-4v14l-5-4H4z"></path>
      <path d="M17 9l5 6M22 9l-5 6"></path>
    </svg>
  </button>

  <!-- Lanterns (desktop) -->
  <div class="sd-lantern sd-lantern-left sd-anim" aria-hidden="true">
    <div class="sd-lantern-rope"></div>
    <img src="assets/images/spin/lantern.webp" alt="">
  </div>
  <div class="sd-lantern sd-lantern-right sd-anim" aria-hidden="true">
    <div class="sd-lantern-rope"></div>
    <img src="assets/images/spin/lantern.webp" alt="">
  </div>

  <!-- Hero -->
  <section class="sd-hero">
    <div class="sd-hero-stage">
      <img class="sd-dancer sd-dancer-l sd-anim" src="assets/images/spin/dancer-girl.webp" alt="" aria-hidden="true">
      <div class="sd-logo-wrap">
        <div class="sd-logo-glow" aria-hidden="true"></div>
        <div class="sd-logo-rays sd-anim" aria-hidden="true"></div>
        <img class="sd-logo" src="assets/images/spin/navratri-logo.webp" alt="9 Ratri Mahashagun Offer">
      </div>
      <img class="sd-dancer sd-dancer-r sd-anim" src="assets/images/spin/dancer-boy.webp" alt="" aria-hidden="true">
    </div>

    <p class="sd-tagline">Buy. Spin. Win.</p>
    <h1 class="sd-headline">Spin &amp; Win This Navratri</h1>
    <div class="sd-dates">
      <span class="sd-dates-rule"></span>
      <span>11 – 20 October 2026</span>
      <span class="sd-dates-rule"></span>
    </div>
  </section>

  <!-- Wheel -->
  <section class="sd-wheel-section">
    <div class="sd-wheel-container">
      <div class="sd-wheel-rays sd-anim" aria-hidden="true"></div>
      <div class="sd-wheel-glow" aria-hidden="true"></div>

      <!-- Decorative frame: outer gold rim + dark burgundy ring + inner gold rim -->
      <div class="sd-wheel-frame" aria-hidden="true"></div>

      <!-- Bulbs sit on the dark burgundy ring -->
      <div class="sd-bulbs" aria-hidden="true">
        <div *ngFor="let b of bulbs; let i = index"
             class="sd-bulb"
             [style.transform]="'rotate(' + (i * (360 / bulbs.length)) + 'deg)'">
          <span class="sd-bulb-dot"></span>
        </div>
      </div>

      <!-- Spinning wheel -->
      <div class="sd-wheel"
           [style.transform]="'rotate(' + wheelRotation + 'deg)'">
        <div class="sd-wheel-outer"></div>
        <div class="sd-wheel-inner"></div>

        <div class="sd-wedge" *ngFor="let w of wedges; let i = index"
             [style.transform]="'rotate(' + w.deg + 'deg)'">
          <div class="sd-wedge-divider"></div>
          <div class="sd-wedge-gift" [class.sd-wedge-won]="i === wonWedgeIndex">
            <img *ngIf="i === wonWedgeIndex && lastWonGift?.thumbnailUrl"
                 [src]="'https://apis.smartdukaan.com/document/' + lastWonGift.thumbnailUrl"
                 (error)="handleImageError($event)" alt="">
            <img *ngIf="i !== wonWedgeIndex"
                 src="assets/images/spin/wheel-wedge-back.webp" alt="" aria-hidden="true">
          </div>
        </div>

        <!-- Highlight -->
        <div class="sd-wheel-highlight" aria-hidden="true"></div>
      </div>

      <!-- Pointer flap -->
      <div class="sd-pointer" aria-hidden="true">
        <div class="sd-pointer-body">
          <div class="sd-pointer-knob"></div>
        </div>
      </div>

      <!-- Center hub button -->
      <button type="button" class="sd-hub"
              [disabled]="isSpinning || !hasAnySpin"
              (click)="spin()">
        <img class="sd-hub-img sd-anim" src="assets/images/spin/wheel-hub.webp" alt="">
        <span class="sd-hub-label">SPIN</span>
      </button>

      <!-- Dandiya stands (placed after wheel so they render ABOVE the wheel body) -->
      <img class="sd-dandiya sd-dandiya-l" src="assets/images/spin/dandiya-stand-left.webp" alt="" aria-hidden="true">
      <img class="sd-dandiya sd-dandiya-r" src="assets/images/spin/dandiya-stand-right.webp" alt="" aria-hidden="true">
    </div>

    <!-- CTA + spins -->
    <div class="sd-cta-wrap">
      <button type="button" class="sd-cta"
              [class.sd-cta-done]="isDone"
              [disabled]="isSpinning || (!hasAnySpin && !isDone)"
              (click)="handleCta()">
        <ng-container *ngIf="isSpinning">Spinning...</ng-container>
        <ng-container *ngIf="!isSpinning && isDone">अपना gift देखें</ng-container>
        <ng-container *ngIf="!isSpinning && !isDone && hasAnySpin">Tap to Spin</ng-container>
        <ng-container *ngIf="!isSpinning && !isDone && !hasAnySpin">No spins left</ng-container>
      </button>
      <div class="sd-spins-line">
        <ng-container *ngIf="isDone">
          <span class="sd-spins-done">{{ customerMobile }} · Spin पूरा हुआ</span>
          <button type="button" class="sd-logout" (click)="logout()">Log out</button>
        </ng-container>
        <span *ngIf="!isDone && !loading && hasAnySpin">{{ spinsLeft }} spin{{ spinsLeft === 1 ? '' : 's' }} available</span>
        <span *ngIf="!isDone && loading">Loading your gifts...</span>
      </div>
    </div>

    <!-- Empty state -->
    <div *ngIf="!loading && allGifts.length === 0" class="sd-empty">
      <p>No scratch cards yet. Purchase a smartphone during Navratri to earn a spin!</p>
    </div>
  </section>

  <!-- Terms & Conditions -->
  <section class="sd-terms">
    <h2 class="sd-terms-title">Terms &amp; conditions</h2>
    <ul class="sd-terms-list">
      <li>Offer valid 11–20 October 2026 on smartphone purchases at participating SmartDukaan stores.</li>
      <li>One spin per smartphone invoice, linked to the mobile number given at billing and verified by OTP.</li>
      <li>Gifts are handed over after the spin, against the Claim ID shown. Products shown are only suggestive and the actual product may vary.</li>
      <li>Gifts subject to stock availability. Only eligible smartphone models qualify. Offer is non-transferable and cannot be exchanged for cash.</li>
    </ul>
  </section>

  <!-- How it works -->
  <section class="sd-how">
    <div class="sd-how-title-row">
      <img class="sd-diya sd-anim" src="assets/images/spin/diya.webp" alt="" aria-hidden="true">
      <h2 class="sd-how-title">How it works</h2>
      <img class="sd-diya sd-anim sd-diya-flip" src="assets/images/spin/diya.webp" alt="" aria-hidden="true">
    </div>
    <p class="sd-how-sub">Four simple steps to your Navratri gift</p>
    <div class="sd-steps">
      <div class="sd-step" *ngFor="let st of steps">
        <div class="sd-step-head">
          <span class="sd-step-n">{{ st.n }}</span>
        </div>
        <h3 class="sd-step-title">{{ st.title }}</h3>
        <p class="sd-step-desc">{{ st.desc }}</p>
      </div>
    </div>
  </section>

  <!-- Result modal -->
  <div class="sd-modal-backdrop" *ngIf="showResult" (click)="closeResult()">
    <div class="sd-modal" (click)="$event.stopPropagation()">
      <button type="button" class="sd-modal-close" (click)="closeResult()" aria-label="Close">×</button>

      <!-- Red header with sunburst and gift -->
      <div class="sd-modal-head">
        <div class="sd-modal-dandiya" aria-hidden="true">
          <img src="assets/images/spin/dandiya-stand-left.webp" alt="">
          <img src="assets/images/spin/dandiya-stand-right.webp" alt="">
        </div>
        <h2 class="sd-modal-title">बधाई हो!</h2>
        <p class="sd-modal-subtitle">आपका ASSURED GIFT</p>

        <div class="sd-prize-wrap">
          <div class="sd-prize-rays" aria-hidden="true"></div>
          <div class="sd-prize-glow" aria-hidden="true"></div>
          <div class="sd-prize-frame">
            <img *ngIf="resultGift?.thumbnailUrl"
                 [src]="'https://apis.smartdukaan.com/document/' + resultGift.thumbnailUrl"
                 (error)="handleImageError($event)" alt="">
          </div>
        </div>
      </div>

      <!-- Cream body with claim details -->
      <div class="sd-modal-body">
        <h3 class="sd-prize-name">{{ resultGift?.giftName || resultGift?.offerName }}</h3>

        <div class="sd-screenshot-banner">
          <div class="sd-screenshot-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="#FFF4D6" stroke-width="2"
                 stroke-linecap="round" stroke-linejoin="round">
              <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
              <circle cx="12" cy="13" r="4"></circle>
            </svg>
          </div>
          <div class="sd-screenshot-text">
            <strong>Screenshot ज़रूर लें</strong>
            <span>Gift लेते समय यह Claim ID दिखानी होगी</span>
          </div>
        </div>

        <div class="sd-claim-pill">
          <span class="sd-claim-label">Claim ID</span>
          <span class="sd-claim-id">{{ claimId }}</span>
          <button type="button" class="sd-claim-copy" (click)="copyClaimId()">Copy</button>
        </div>

        <p class="sd-claim-note">
          <span class="sd-claim-giftIcon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="#9E0F1B" stroke-width="2"
                 stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 12 20 22 4 22 4 12"></polyline>
              <rect x="2" y="7" width="20" height="5"></rect>
              <line x1="12" y1="22" x2="12" y2="7"></line>
              <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>
            </svg>
          </span>
          आपका gift जल्द ही दिया जाएगा। हम इसी Claim ID के साथ SMS भेजेंगे।
        </p>

        <button type="button" class="sd-modal-cta" (click)="closeResult()">Done</button>
      </div>
    </div>
    <div class="sd-confetti" aria-hidden="true">
      <span *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29]"
            class="sd-confetti-piece"
            [style.left.%]="(i * 97) % 100"
            [style.animation-delay.s]="(i % 10) * 0.1"
            [style.background]="'hsl(' + (i * 37 % 360) + ', 85%, 60%)'"></span>
    </div>
  </div>
</div>
